var map = {
	"./1.png": 1033,
	"./1313161554.png": 1034,
	"./1313161555.png": 1035,
	"./137.png": 1036,
	"./4.png": 1037,
	"./42161.png": 1038,
	"./5.png": 1039,
	"./56.png": 1040,
	"./66.png": 1041,
	"./97.png": 1042,
	"./BSC.png": 1043,
	"./aurora-test.png": 1044,
	"./aurora.png": 1045,
	"./bsc-test.png": 1046,
	"./bsc.png": 1047,
	"./ethereum.png": 1048,
	"./goerli-test.png": 1049,
	"./matic.png": 1050,
	"./okc.png": 1051,
	"./rinkeby-test.png": 1052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;